import styled from 'styled-components';
import { Content } from './../../Components/ShowMoreTotalAdminFee/styles.js';
import { Table } from 'antd';

export const ContentStyles = styled(Content)`
    width: 90%;
`

export const FeeHeadWrap = styled.div`
    margin-left: ${props => props.marginLeft};
    margin-bottom: ${props => props.marginBottom};
    margin-top: ${props => props.marginTop};
`

export const ContentWrapMain = styled.div`
    margin-left: ${props => props.marginLeft};
    ul {
    margin: 0 !important;
}
`

export const InvestFeeButton = styled.span`
    cursor: pointer;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: normal;
    letter-spacing: 0.5px;
    color: ${props => props.theme.fontColors.primary};
    margin-left: 35px;
    margin-right: 10px;
    border: 1px solid ${props => props.theme.border.teal};
    padding: 10px 20px;
    min-width:150px;
    @media only screen and (min-width: 320px) {
        margin-left:42px;
      }
    @media only screen and (min-width: 425px) and (max-width: 767px) {
        margin-left:63px;
    }
    @media only screen and (max-width: 322px) {
        margin-left:15px;
    }
`

export const ButtonWrap = styled.div`
    padding-left: 45px;
`

export const AnnualScheduleTable = styled(Table)`
margin-left: 35px;
margin-bottom: 23px;
.ant-table-thead {
    border-top: 1px solid ${props => props.theme.border.pill};
    th {
        border-bottom: none;
        background: ${props => props.theme.backgroundColor.layoutLight};
        padding: 25px 20px 22px 20px;
        min-width: 85px;
    }
  }
.ant-table-row:nth-child(2n + 1) {
      background-color: ${props => props.theme.backgroundColor.cardDark} !important;
    }
.ant-table-tbody {
    td {
        padding: 25px 20px 22px 20px;
    }
}
.ant-table-thead > tr:first-child > th:last-child{
    white-space: nowrap;
}
`

export const ColumnHeader = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.13;
    color: ${props => props.theme.fontColors.headingColor};
`
export const FeeTable = styled.div`
    padding: 0 35px;
    margin-top: 10px;
    margin-bottom: 30px;
    table{
        width:100%;
        border-top: 1px solid #b6bdbd;
    }
    th:first-child{
        padding-left: 45px;
    }
    th{
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        font-size: ${props => props.theme.fontSize.primary};
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        color: ${props => props.theme.fontColors.headingColor};
        padding: 10px;
        min-width: 45px;
        font-weight: ${props => props.theme.fontWeight.normal};
    }
    td:first-child{
        padding-left: 45px;
    }
    td{
        padding: 20px 10px;
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.primary};
        font-weight: ${props => props.theme.fontWeight.normal};
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: ${props => props.theme.fontColors.thead};
        a{
            color: ${props => props.theme.colors.primaryColor};
            text-decoration: underline;
            cursor: pointer;
        }
    }
    tbody tr:nth-child(odd){
        background-color: ${props => props.theme.backgroundColor.cardDark};
    }
    @media only screen and (max-width: 768px) {
        padding: 0;
        thead{
            display:${props => props.mDisplayTitle ? 'contents' : 'none'};
        }
        th:first-child{
            padding-left: 0px;
        }
        td:first-child{
            padding-left: 10px;
        }
        th,td{
            font-size: ${props => props.theme.fontSize.secondary};
        }
    }
    @media only screen and (max-width: 322px) {
        th{
            padding-left: 0px;
        }
        td{
            padding-left: 10px;
        }
    }
`